import { useEffect } from 'react';
import { onCLS, onFID, onLCP, onFCP, onTTFB } from 'web-vitals';

// Component to monitor and report performance metrics
const PerformanceMonitor = () => {
  useEffect(() => {
    // Function to log metrics to console and potentially send to analytics
    const logMetric = ({ name, value, id }) => {
      console.log(`Web Vital: ${name} = ${value}`);
      
      // Add your analytics service here if you want to track metrics
      // For example, Google Analytics:
      // if (window.gtag) {
      //   window.gtag('event', name, {
      //     value: Math.round(value),
      //     metric_id: id,
      //     metric_value: value,
      //     metric_delta: 0,
      //   });
      // }
    };

    // Register observers for each web vital
    onCLS(logMetric); // Cumulative Layout Shift
    onFID(logMetric); // First Input Delay
    onLCP(logMetric); // Largest Contentful Paint
    onFCP(logMetric); // First Contentful Paint
    onTTFB(logMetric); // Time to First Byte

    // Store metrics in localStorage for debugging
    const saveMetricsToLocalStorage = (metric) => {
      try {
        const metrics = JSON.parse(localStorage.getItem('webVitals') || '{}');
        metrics[metric.name] = metric.value;
        localStorage.setItem('webVitals', JSON.stringify(metrics));
      } catch (e) {
        console.error('Error saving metrics to localStorage', e);
      }
    };

    // Add additional observers that save to localStorage
    onCLS(saveMetricsToLocalStorage);
    onFID(saveMetricsToLocalStorage);
    onLCP(saveMetricsToLocalStorage);
    onFCP(saveMetricsToLocalStorage);
    onTTFB(saveMetricsToLocalStorage);

    // Log navigation performance data
    setTimeout(() => {
      if (window.performance) {
        // Using Navigation Timing API Level 2 when available
        if (window.performance.getEntriesByType && window.performance.getEntriesByType('navigation').length > 0) {
          const navTiming = window.performance.getEntriesByType('navigation')[0];
          const pageLoadTime = Math.round(navTiming.loadEventEnd - navTiming.startTime);
          const connectTime = Math.round(navTiming.responseEnd - navTiming.requestStart);
          const renderTime = Math.round(navTiming.domComplete - navTiming.domContentLoadedEventStart);
          
          if (pageLoadTime > 0) console.log(`Total Page Load Time: ${pageLoadTime}ms`);
          if (connectTime > 0) console.log(`Server Connect Time: ${connectTime}ms`);
          if (renderTime > 0) console.log(`DOM Render Time: ${renderTime}ms`);
          
          try {
            const metrics = JSON.parse(localStorage.getItem('navigationTiming') || '{}');
            metrics.pageLoadTime = pageLoadTime;
            metrics.connectTime = connectTime;
            metrics.renderTime = renderTime;
            localStorage.setItem('navigationTiming', JSON.stringify(metrics));
          } catch (e) {
            console.error('Error saving navigation timing to localStorage', e);
          }
        } 
        // Fallback to the older API
        else if (window.performance.timing) {
          const perfData = window.performance.timing;
          const pageLoadTime = perfData.loadEventEnd - perfData.navigationStart;
          
          // Only log positive values
          if (pageLoadTime > 0) {
            console.log(`Total Page Load Time: ${pageLoadTime}ms`);
            
            // More detailed metrics
            const connectTime = perfData.responseEnd - perfData.requestStart;
            const renderTime = perfData.domComplete - perfData.domLoading;
            
            if (connectTime > 0) console.log(`Server Connect Time: ${connectTime}ms`);
            if (renderTime > 0) console.log(`DOM Render Time: ${renderTime}ms`);
            
            try {
              // Store in localStorage
              const metrics = JSON.parse(localStorage.getItem('navigationTiming') || '{}');
              metrics.pageLoadTime = pageLoadTime;
              metrics.connectTime = connectTime;
              metrics.renderTime = renderTime;
              localStorage.setItem('navigationTiming', JSON.stringify(metrics));
            } catch (e) {
              console.error('Error saving navigation timing to localStorage', e);
            }
          }
        }
      }
    }, 1000); // Delay timing calculation to ensure the page has fully loaded
  }, []);

  // This component doesn't render anything
  return null;
};

export default PerformanceMonitor; 